import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ThreadViewComponent } from './thread-view/thread-view.component';

@Injectable({
  providedIn: 'root',
})
@Injectable()
export class DeactivateGuard {
  // constructor(private dialogService: DialogService) {}

  canDeactivate(
    component: ThreadViewComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    // if (component.messageBox.nativeElement.value) {
    //   return this.dialogService.confirm(
    //     'You may have unsaved changes, would you still like to leave?'
    //   );
    // }
    return true;
  }
}
